import { render } from "./formDataSelect.vue?vue&type=template&id=a9b88372"
import script from "./formDataSelect.vue?vue&type=script&lang=js"
export * from "./formDataSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__